import { RouteRecordRaw, RouterView } from 'vue-router';
import { h } from 'vue';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/map',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/map',
                    name: 'map',
                    component: () => import("./views/map.vue")
                },
            ]
        }
    ];
};